import { render, staticRenderFns } from "./VendorAddModal.vue?vue&type=template&id=40c89504&scoped=true&"
import script from "./VendorAddModal.vue?vue&type=script&lang=js&"
export * from "./VendorAddModal.vue?vue&type=script&lang=js&"
import style0 from "./VendorAddModal.vue?vue&type=style&index=0&id=40c89504&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c89504",
  null
  
)

export default component.exports